import styled from 'styled-components';
import { mt } from '@lendi-ui/spacing';

export const AccordionContentWrapper = styled.div`
  /* Gives a margin top to all its children except the first */
  & > * {
    ${mt('md')} :first-child {
      ${mt('nil')}
    }
  }
`;

export const AccordionDeleteWrapper = styled.div`
  text-align: center;
`;
